import Vue from "vue";
import VueRouter from "vue-router";
import Home from "../views/Home.vue";
import dashboard_ports from "../views/dashboard_ports.vue";
import dashboard_vifs from "../views/dashboard_vifs.vue";
import dashboard_nat_maps from "../views/dashboard_nat_maps.vue";
import dashboard_vif_monitoring from "../views/dashboard_vif_monitoring.vue";
import vif from "../views/vif.vue";
import ipv6_vif from "../views/ipv6_vif.vue";
import vif_ip_addr from "../views/vif_ip_addr.vue";
import vif_ipv6_addr from "../views/vif_ipv6_addr.vue";
import ip_route_table from "../views/ip_route_table.vue";
import ipv6_route_table from "../views/ipv6_route_table.vue";
import ipv4_route from "../views/ipv4_route.vue";
import ipv6_route from "../views/ipv6_route.vue";
import pbr_rules from "../views/pbr_rules.vue";
import pbr6_rules from "../views/pbr6_rules.vue";
import radius_client from "../views/radius_client.vue";
import pppoe_profile from "../views/pppoe_profile.vue";
import pppoe_profile_bindings from "../views/pppoe_profile_bindings.vue";
import ip_pool from "../views/ip_pool.vue";
import ipv6_pool from "../views/ipv6_pool.vue";
import pppoe_settings from "../views/pppoe_settings.vue";
import pppoe_ipv4_subsc from "../views/pppoe_ipv4_subsc.vue";
import pppoe_ipv6_subsc from "../views/pppoe_ipv6_subsc.vue";
import nat_policy from "../views/nat_policy.vue";
import det_nat from "../views/det_nat.vue";
import nat3 from "../views/nat3.vue";
import nat3_sessions from "../views/nat3_sessions.vue";
import det_nat_sessions from "../views/det_nat_sessions.vue";
import nat_interface from "../views/nat_interface.vue";
import nat11 from "../views/nat11.vue";
import nat11_sessions from "../views/nat11_sessions.vue";
import nat11_trans_rules from "../views/nat11_trans_rules.vue";
import sysctl from "../views/sysctl.vue";
import config_save from "../views/config_save.vue";
import coa from "../views/coa.vue";
import about from "../views/about.vue";
import iface_graph from "../views/iface_graph.vue";
import ipoe_ipv4_subsc from "../views/ipoe_ipv4_subsc.vue";
import ipoe_profile from "../views/ipoe_profile.vue";
import ipoe_profile_bindings from "../views/ipoe_profile_bindings.vue";
import ipoe_settings from "../views/ipoe_settings.vue";
import prefix_maps from "../views/prefix_maps.vue";
import prefix_map_entries from "../views/prefix_map_entries.vue";
import LoginUser from "../components/LoginUser.vue";
import nel from "../views/nel.vue";
import store from "../store/index.js";

Vue.use(VueRouter);

const routes = [
  {
    path: "/",
    name: "home",
    component: Home
  },
  {
    path: "/login",
    name: "login",
    component: LoginUser
  },
  {
    path: "/dashboard/ports",
    name: "dashboard_ports",
    component: dashboard_ports
  },
  {
    path: "/dashboard/vifs",
    name: "dashboard_vifs",
    component: dashboard_vifs
  },
  {
    path: "/dashboard/nat_maps",
    name: "dashboard_nat_maps",
    component: dashboard_nat_maps
  },
  {
    path: "/dashboard/vifs/monitoring",
    name: "dashboard_vif_monitoring",
    component: dashboard_vif_monitoring
  },
  {
    path: "/logout",
    name: "logout",
    component: {
      beforeRouteEnter(to, from, next) {
        store.dispatch("logout");
        return next("/login")
      },
    }
  },  
  {
    path: "/about",
    name: "about",
    component: about
  }, 
  {
    path: "/vif",
    name: "vif",
    component: vif
  },
  {
    path: "/vif_ip_addr",
    name: "vif_ip_addr",
    component: vif_ip_addr
  },
  {
    path: "/vif_ipv6_addr",
    name: "vif_ipv6_addr",
    component: vif_ipv6_addr
  },
  {
    path: "/ip_route_table",
    name: "ip_route_table",
    component: ip_route_table
  },
  {
    path: "/ipv6_vif",
    name: "ipv6_vif",
    component: ipv6_vif
  },
  {
    path: "/ipv6_route_table",
    name: "ipv6_route_table",
    component: ipv6_route_table
  },
  {
    path: "/ipv4_route",
    name: "ipv4_route",
    component: ipv4_route
  },
  {
    path: "/ipv6_route",
    name: "ipv6_route",
    component: ipv6_route
  },
  {
    path: "/pbr_rules",
    name: "pbr_rules",
    component: pbr_rules
  },
  {
    path: "/pbr6_rules",
    name: "pbr6_rules",
    component: pbr6_rules
  },
  {
    path: "/radius_client",
    name: "radius_client",
    component: radius_client
  },
  {
    path: "/ip_pool",
    name: "ip_pool",
    component: ip_pool
  },  
  {
    path: "/ipv6_pool",
    name: "ipv6_pool",
    component: ipv6_pool
  },  
  {
    path: "/pppoe_ipv4_subsc",
    name: "pppoe_ipv4_subsc",
    component: pppoe_ipv4_subsc
  },
  {
    path: "/pppoe_ipv6_subsc",
    name: "pppoe_ipv6_subsc",
    component: pppoe_ipv6_subsc
  },
  {
    path: "/pppoe_profile",
    name: "pppoe_profile",
    component: pppoe_profile
  },
  {
    path: "/pppoe_settings",
    name: "pppoe_settings",
    component: pppoe_settings
  },
  {
    path: "/nat/nat_policy",
    name: "nat_policy",
    component: nat_policy
  },
  {
    path: "/nat/det_nat",
    name: "det_nat",
    component: det_nat
  },
  {
    path: "/nat/nat3",
    name: "nat3",
    component: nat3
  },
  {
    path: "/nat/nat3/sessions",
    name: "nat3_sessions",
    component: nat3_sessions
  },
  {
    path: "/nat/det_nat/sessions",
    name: "det_nat_sessions",
    component: det_nat_sessions
  },  
  {
    path: "/nat/interface",
    name: "nat_interface",
    component: nat_interface
  },
  {
    path: "/pppoe_profile_bindings",
    name: "pppoe_profile_bindings",
    component: pppoe_profile_bindings
  },
  {
    path: "/nat/nat11",
    name: "nat11",
    component: nat11
  },
  {
    path: "/nat/nat11/sessions",
    name: "nat11_sessions",
    component: nat11_sessions
  },
  {
    path: "/nat/nat11/trans_rules",
    name: "nat11_trans_rules",
    component: nat11_trans_rules
  },
  {
    path: "/sysctl",
    name: "sysctl",
    component: sysctl
  },
  {
    path: "/config_save",
    name: "config_save",
    component: config_save
  },
  {
    path: "/coa",
    name: "coa",
    component: coa
  },
  {
    path: "/iface_graph",
    name: "iface_graph",
    component: iface_graph
  },
  {
    path: "/ipoe_ipv4_subsc",
    name: "ipoe_ipv4_subsc",
    component: ipoe_ipv4_subsc
  },
  {
    path: "/ipoe_profile",
    name: "ipoe_profile",
    component: ipoe_profile
  },
  {
    path: "/ipoe_profile_bindings",
    name: "ipoe_profile_bindings",
    component: ipoe_profile_bindings
  },
  {
    path: "/ipoe_settings",
    name: "ipoe_settings",
    component: ipoe_settings
  },
  {
    path: "/prefix_maps",
    name: "prefix_maps",
    component: prefix_maps
  },
  {
    path: "/prefix_map_entries",
    name: "prefix_map_entries",
    component: prefix_map_entries
  },
  {
    path: "/nel",
    name: "nel",
    component: nel
  },
];

const router = new VueRouter({
  mode: "history",
  base: process.env.BASE_URL,
  routes
});

router.beforeEach((to, from, next) => {
  const public_pages = ["/login", "/about"];

  var auth_required = true;
  for (var i = 0; i < public_pages.length; i++)
    if (to.path.includes(public_pages[i])) {
      auth_required = false;
      break;
    }
  const access_token = localStorage.getItem('access_token')

  // redirect to login page if user is not logged in and trying to access a restricted page
  if (auth_required && !access_token) {
    return next("/login")
  }

  next();
});

export default router;
